import { render } from "./TabView.vue?vue&type=template&id=5a535406&bindings={\"items\":\"props\",\"borderTop\":\"props\",\"currentTab\":\"data\",\"prevTab\":\"data\",\"changeTab\":\"options\"}"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"

import "./TabView.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script